import { createApiCall } from 'lib/base';

interface CreateIdentificationImageParams {
  userId: string;
  imageUrl: string;
  formData: FormData; // Add formData to the interface
}

const CREATE_IDENTIFICATION_IMAGE = 'CREATE_IDENTIFICATION_IMAGE'; // Corrected action name
export const createIdentificationImageApi = createApiCall<
  CreateIdentificationImageParams
>(CREATE_IDENTIFICATION_IMAGE, ({ userId, formData }) => ({
  endpoint: `api/admin/users/${userId}/identification-images`,
  method: 'POST',
  body: formData,
}));

export default createIdentificationImageApi;
